import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import { apiTokenInstructions, getProviderFormLabel } from '../utils';

const SignInInsperityApi = ({
  isLoading,
  onSubmit,
  client,
  handleClick,
  provider,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = apiTokenInstructions(provider.displayName, client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      onSubmit={onSubmit}
      divider
      fieldNames={['instructionCheck', 'companyId', 'apiToken']}
      render={({ instructionCheck, companyId, apiToken }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              <Input
                value={companyId.value}
                onChange={(event) => companyId.onChange(event.target.value)}
                invalid={companyId.invalid}
                label="Company ID"
                id="companyId"
              />
              <Input
                value={apiToken.value}
                onChange={(event) => apiToken.onChange(event.target.value)}
                invalid={apiToken.invalid}
                label="API Token"
                id="apiToken"
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Use a Username and Password instead
              </SwitchImplementationButton>
            )}
            <LoaderButton
              isLoading={isLoading}
              disabled={
                isLoading ||
                !instructionCheck.value ||
                !companyId.value ||
                !apiToken.value
              }
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default SignInInsperityApi;
